function existy(x) { return x != null };

function cat() {
    var head = _.first(arguments);
    if (existy(head))
        return head.concat.apply(head, _.rest(arguments));
    else
        return [];
}

function checker(/* validators */) {
    var validators = _.toArray(arguments);

    return function (obj) {
        return _.reduce(validators, function (errs, check) {
            if (check(obj))
                return errs
            else
                return _.chain(errs).push(check.message).value();
        }, []);
    };
}

function validator(message, fun) {
    var f = function (/* args */) {
        return fun.apply(fun, arguments);
    };

    f['message'] = message;
    return f;
}

function aMap(obj) {
    return _.isObject(obj);
}

function anArray(obj) {
    return _.isArray(obj);
}

function aFunction(obj) {
    return _.isFunction(obj);
}

function anObservable(obj) {
    return ko.isObservable(obj);
}

function hasKeys() {
    var KEYS = _.toArray(arguments);

    var fun = function (obj) {
        return _.every(KEYS, function (k) {
            return _.has(obj, k);
        });
    };

    fun.message = cat(["Must have values for keys:"], KEYS).join(" ");
    return fun;
}

function must(/*data, cmd*/) {
    var ps = _.toArray(arguments),
		data = ps[0],
		cmd = checker.apply(checker, _(ps).rest(1)),
		errors = cmd(data);

    if (!_.isEmpty(errors)) {
        throw errors.join(". ");
    }
}

/**
 * Mixin Funktionalität.
 */
function mixin(to, from) {
    from.call(to.prototype);
}

function showAlertDialog(data) {
    var dummyElement = document.createElement("div");
    var $dialog = $(dummyElement)
        .html("<div>" + ((data.message + '')) + "</div>")
        .dialog({
            open: function (event, ui) { $(".ui-dialog-titlebar-close", ui.dialog).hide(); },
            autoOpen: false,
            modal: true,
            width: 400,
            height: "auto",
            title: data.title || '',
            buttons: [
                {
                    text: culture ? dialogMLlocales[culture.slice(0,2)].OK : dialogMLlocales['en'].OK,
                    click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        });

    if (!data.title) {
        $(dummyElement).parent().find('.ui-dialog-titlebar').css('display', 'none');
    }

    $dialog.dialog('open');
};

function showConfirmDialog(data, okCallback, cancelCallback) {
    var dummyElement = document.createElement("div");

    var buttons = [
        {
            text: culture ? dialogMLlocales[culture.slice(0, 2)].OK : dialogMLlocales['en'].OK,
            click: function () {
                $(this).dialog("close");
                if (okCallback) okCallback();
            }
        }
    ];

    if (cancelCallback != null) {
        buttons.push({
            text: culture ? dialogMLlocales[culture.slice(0, 2)].CANCEL : dialogMLlocales['en'].CANCEL,
            click: function () {
                cancelCallback();
                $(this).dialog("close");
            }
        });
    }


    var $dialog = $(dummyElement)
        .html("<div>" + ((data.message + '')) + "</div>")
        .dialog({
            open: function (event, ui) { $(".ui-dialog-titlebar-close", ui.dialog).hide(); },
            autoOpen: false,
            modal: true,
            width: 400,
            height: "auto",
            dialogClass: 'noTitleStuff',
            title: data.title || '',
            buttons: buttons
        });

    if (!data.title) {
        $(dummyElement).parent().find('.ui-dialog-titlebar').css('display', 'none');
    }
    $dialog.dialog('open');
   
}

/**
 * standard locales. Please add more according to ISO 639-1 standard. Multiple language variants are
 * unlikely to be required. If this gets too large it can be split out into separate JS files.
 */
var dialogMLlocales = {
    ar: {
        OK: "موافق",
        CANCEL: "الغاء",
        CONFIRM: "تأكيد"
    },
    az: {
        OK: "OK",
        CANCEL: "İmtina et",
        CONFIRM: "Təsdiq et"
    },
    br: {
        OK: "OK",
        CANCEL: "Cancelar",
        CONFIRM: "Sim"
    },
    cs: {
        OK: "OK",
        CANCEL: "Zrušit",
        CONFIRM: "Potvrdit"
    },
    da: {
        OK: "OK",
        CANCEL: "Annuller",
        CONFIRM: "Accepter"
    },
    de: {
        OK: "OK",
        CANCEL: "Abbrechen",
        CONFIRM: "Akzeptieren"
    },
    el: {
        OK: "Εντάξει",
        CANCEL: "Ακύρωση",
        CONFIRM: "Επιβεβαίωση"
    },
    en: {
        OK: "OK",
        CANCEL: "Cancel",
        CONFIRM: "OK"
    },
    es: {
        OK: "OK",
        CANCEL: "Cancelar",
        CONFIRM: "Aceptar"
    },
    eu: {
        OK: "OK",
        CANCEL: "Ezeztatu",
        CONFIRM: "Onartu"
    },
    et: {
        OK: "OK",
        CANCEL: "Katkesta",
        CONFIRM: "OK"
    },
    fa: {
        OK: "قبول",
        CANCEL: "لغو",
        CONFIRM: "تایید"
    },
    fi: {
        OK: "OK",
        CANCEL: "Peruuta",
        CONFIRM: "OK"
    },
    fr: {
        OK: "OK",
        CANCEL: "Annuler",
        CONFIRM: "Confirmer"
    },
    he: {
        OK: "אישור",
        CANCEL: "ביטול",
        CONFIRM: "אישור"
    },
    hu: {
        OK: "OK",
        CANCEL: "Mégsem",
        CONFIRM: "Megerősít"
    },
    hr: {
        OK: "OK",
        CANCEL: "Odustani",
        CONFIRM: "Potvrdi"
    },
    id: {
        OK: "OK",
        CANCEL: "Batal",
        CONFIRM: "OK"
    },
    it: {
        OK: "OK",
        CANCEL: "Annulla",
        CONFIRM: "Conferma"
    },
    ja: {
        OK: "OK",
        CANCEL: "キャンセル",
        CONFIRM: "確認"
    },
    ko: {
        OK: "OK",
        CANCEL: "취소",
        CONFIRM: "확인"
    },
    lt: {
        OK: "Gerai",
        CANCEL: "Atšaukti",
        CONFIRM: "Patvirtinti"
    },
    lv: {
        OK: "Labi",
        CANCEL: "Atcelt",
        CONFIRM: "Apstiprināt"
    },
    nl: {
        OK: "OK",
        CANCEL: "Annuleren",
        CONFIRM: "Accepteren"
    },
    no: {
        OK: "OK",
        CANCEL: "Avbryt",
        CONFIRM: "OK"
    },
    pl: {
        OK: "OK",
        CANCEL: "Anuluj",
        CONFIRM: "Potwierdź"
    },
    pt: {
        OK: "OK",
        CANCEL: "Cancelar",
        CONFIRM: "Confirmar"
    },
    ru: {
        OK: "OK",
        CANCEL: "Отмена",
        CONFIRM: "Применить"
    },
    sk: {
        OK: "OK",
        CANCEL: "Zrušiť",
        CONFIRM: "Potvrdiť"
    },
    sl: {
        OK: "OK",
        CANCEL: "Prekliči",
        CONFIRM: "Potrdi"
    },
    sq: {
        OK: "OK",
        CANCEL: "Anulo",
        CONFIRM: "Prano"
    },
    sv: {
        OK: "OK",
        CANCEL: "Avbryt",
        CONFIRM: "OK"
    },
    th: {
        OK: "ตกลง",
        CANCEL: "ยกเลิก",
        CONFIRM: "ยืนยัน"
    },
    tr: {
        OK: "Tamam",
        CANCEL: "İptal",
        CONFIRM: "Onayla"
    },
    uk: {
        OK: "OK",
        CANCEL: "Відміна",
        CONFIRM: "Прийняти"
    }
};

(function () {
    /**
		Performs a jQuery ajax request with type "METHOD" and "cache: false". 
	
		@param {string} url The url for the request 
        @param {object} options Add options to $.ajax()
	*/
    $.postJSON = function (url, data, options) {
        function sanitize(d) {
            return _(d).mapObject(function (val, key) {
                return _(val).isFunction()
                    ? val()
                    : val;
            });
        }

        var settings = $.extend(options || {}, {
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            url: url,
            dataType: "json",
            data: JSON.stringify(sanitize(data))
        });

        return $.ajax(settings);
    }

    /// UUUAAAHHHH: Nach Weihnachten fixen!
    $.nonSanitizedPostJSON = function (url, data, options) {
        var settings = $.extend(options || {}, {
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            url: url,
            dataType: "json",
            data: data
        });

        return $.ajax(settings);
    }


    /**
		Performs a jQuery ajax json request with global set to false. 
	
		@param {string} url The url for the request 
        @param {object} options Add options to $.ajax()
	*/
    $.silentGetJSON = function (url, data, options) {
        var settings = $.extend(options || {}, {
            type: 'GET',
            contentType: "application/json; charset=utf-8",
            url: url,
            dataType: "json",
            data: data,
            global: false
        });

        return $.ajax(settings);
    }

    /**
		Performs a jQuery ajax json request with global set to false. 
	
		@param {string} url The url for the request 
        @param {object} options Add options to $.ajax()
	*/
    $.silentPostJSON = function (url, data, options) {
        var settings = $.extend(options || {}, {
            type: 'POST',
            contentType: "application/json; charset=utf-8",
            url: url,
            dataType: "json",
            data: data,
            global: false
        });

        return $.ajax(settings);
    }

    /**
     * Add number of days to date
     */
    Date.prototype.addDays = function (days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    }

    Date.prototype.yyyymmdd = function () {
        var mm = this.getMonth() + 1; // getMonth() is zero-based
        var dd = this.getDate();

        return [this.getFullYear(),
                (mm > 9 ? '' : '0') + mm,
                (dd > 9 ? '' : '0') + dd
        ].join('');
    };
})();